//Styles / MUID
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

const clientDark = createMuiTheme({
  palette: {
    type: "dark"
  }
});

export default clientDark;



// WEBPACK FOOTER //
// ./src/styles/themes/clientDark.js